import "./App.css";
import Parser from "./domains/Parser/Parser";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Parser />
      </header>
    </div>
  );
}

export default App;
